module.exports = __webpack_public_path__ + "fonts/Adelle_Reg.38372e6d.woff";